import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { ChooseResults, Search } from '../components/';
import DataTableContext from '../../../context/DataTableContext';

export const TableActions = (props) => {
  const context = useContext(DataTableContext);
  const { actions } = props;
  const CustomActions = actions ? actions.component : null;

  return (
    <Fragment>
      <Row>
        <Col xs="4" className="mb-3">
          <ChooseResults
            options={context.perPageOptions}
            selected={context.perPage}
            onClick={(e) => context.setPageSize(e.target.value)} />
        </Col>
        <Col id="page-actions" xs="8">
          <Search />
          {
            CustomActions ? <CustomActions actions={actions.actions} /> : null
          }
        </Col>
      </Row>
    </Fragment>
  );
};

TableActions.propTypes = {
  actions: PropTypes.shape({
    component: PropTypes.func.isRequired,
    actions: PropTypes.array.isRequired
  })
};
